export const i18nextNamespace = 'reports';
